export const ADD_INTEREST = 'ADD_INTEREST';
export const DELETE_INTEREST = 'DELETE_INTEREST';
export const ADD_STUDENT_INTEREST = 'ADD_STUDENT_INTEREST';
export const DELETE_STUDENT_INTEREST = 'DELETE_STUDENT_INTEREST';